<template>
  <div class="tableContainer">
    <div v-if="isShowTopTip" class="topTip">*参照资料：</div>
    <div class="tableMainContainer">
      <div v-if="tableTitle" class="tableTitle" v-html="tableTitle" />
      <el-table
        :data="newTableData"
        border
        stripe
        style="width: 100%"
        :header-row-style="{ height: '80px' }"
        header-row-class-name="headerRow"
        row-class-name="bodyRow"
        :cell-style="{ color: cellColor }"
        :span-method="objectSpanMethod"
      >
        <el-table-column
          prop="className"
          :label="isSchool ? '年级' : '班级'"
          align="center"
        />
        <el-table-column prop="gender" label="性别" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row.gender }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="early" label="预警状态" align="center">
          <template slot-scope="props">
            <div v-if="typeof props.row.early === 'number'">
              {{ props.row.early }}
            </div>
            <div v-else>
              {{ props.row.early }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="subhealthy" label="亚健康状态" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row.subhealthy || 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="commonly" label="一般健康状态" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row.commonly || 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="preferably" label="较好健康状态" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row.preferably || 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="high" label="高健康状态" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row.high || 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="合计" align="center">
          <template slot-scope="props">
            <div>
              {{ props.row | filterCount }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tip" class="tip">{{ tip }}</div>
  </div>
</template>
<script>
const tableKey = {
  高健康状态: 'high',
  较好健康状态: 'preferably',
  一般健康状态: 'commonly',
  亚健康状态: 'subhealthy',
  预警状态: 'early'
}
export default {
  filters: {
    filterCount(row) {
      var count = 0
      for (const key in row) {
        if (typeof row[key] === 'number' && !isNaN(row[key])) {
          count += row[key]
        }
      }
      return count
    }
  },
  props: {
    tableData: {
      default: () => {
        return []
      },
      type: Array
    },
    // headers: {
    //   default: () => {
    //     return []
    //   },
    //   type: Array
    // },
    isShowBottomCount: {
      default: false,
      type: Boolean
    },
    cellColor: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    tableTitle: {
      type: String,
      default: undefined
    },
    isShowTopTip: {
      type: Boolean,
      default: false
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    isSchool: {
      tyoe: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    newTableData() {
      var list = []
      this.tableData.value.forEach((ele) => {
        for (let index = 0; index < 3; index++) {
          var obj = {}
          if (index === 0) {
            ele.value.forEach((eles) => {
              obj[tableKey[eles.conclusion]] = eles.theNumberOfMan
            })
            obj['gender'] = '男'
            obj['className'] = ele.className || ele.gradeName || ele.schoolName
            list.push(obj)
          } else if (index === 1) {
            ele.value.forEach((eles) => {
              obj[tableKey[eles.conclusion]] = eles.theNumberOfFemale
            })
            obj['gender'] = '女'
            obj['className'] = ele.className || ele.gradeName || ele.schoolName
            list.push(obj)
          } else if (index === 2) {
            ele.value.forEach((eles) => {
              obj[tableKey[eles.conclusion]] =
                eles.theNumberOfMan + eles.theNumberOfFemale
            })
            obj['gender'] = '合计'
            obj['className'] = ele.className || ele.gradeName || ele.schoolName
            list.push(obj)
          }
        }
      })
      return list
    },
    headers() {
      var headersList = [
        {
          label: '班级',
          key: 'className'
        },
        { label: '性别', key: 'gender' }
      ]
      this.tableData.forEach((ele) => {
        if (headersList.filter((i) => i.label === ele.conclusion).length > 0) { return }
        headersList.push({
          label: ele.conclusion,
          key: tableKey[ele.conclusion]
        })
      })
      return Array.from(new Set(headersList))
    }
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.tableContainer {
  width: 1359px;
  margin: 0 auto 54px;
  .topTip {
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 56px;
  }
  .headerRow th:last-child,
  .bodyRow td:last-child {
    border-right: none;
  }
  .tableMainContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tableTitle {
      width: 100%;
      border: 2px solid #ccc;
      border-bottom: none;
      height: 80px;
      text-align: center;
      line-height: 80px;
      font-size: 32px;
      font-weight: bold;
      color: #333333;
      span {
        color: #fab839;
      }
    }
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: #ccc;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #ccc;
    }
    .el-table__header .cell {
      height: 80px;
      line-height: 80px;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    .el-table__footer .el-table__cell {
      border-top: none;
    }
    .el-table__footer .el-table__cell:last-child {
      border-top: none;
      border-right: none;
    }
    .el-table__footer .cell,
    .el-table__row .cell {
      height: 100px;
      line-height: 100px;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: bold;
    }
    .tableBody {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      .tableHeaders {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 2px solid #ccc;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        div {
          flex: 1;
          height: 100%;
          text-align: center;
          border-right: 2px solid #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .line {
        height: 100px;
        border-bottom: 2px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        .cell {
          border-right: 2px solid #ccc;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          font-weight: bold;
        }
      }
      .tableHeaders div:last-child,
      .line .cell:last-child {
        border-right: none;
      }
    }
    .tableBody .line:last-child {
      border-bottom: none;
    }
  }
  .tip {
    font-size: 20px;
    font-weight: 400;
    color: #fab839;
    margin-top: 30px;
  }
}
</style>
